import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { DxTabPanelTypes } from 'devextreme-angular/ui/tab-panel';
import { Dates, DatePanelItem, datePanelItems, DatePanelItems } from '../../../../../app/types/resource';
import { IDashboardFilterChangeEvent } from '../types/dashboard-types';
import { ScreenService } from '../../../services';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { FilterStateService } from '../../../services/filter-state.service';

@Component({
  standalone: false,
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.css']
})
export class DashboardHeaderComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() selectedItems: Array<number>;
  
  // Remove @Input() properties - get these from FilterStateService instead
  filterOptions: DatePanelItems[];
  showCompleted: boolean;
  showRejected: boolean;

  selectedIndex: number
  
  storageKey: string 

  startDate: Date;
  endDate: Date;

  private dashboardFilterOptionsSubject = new BehaviorSubject<Array<DatePanelItems>>([]);
  dashboardFilterOptions$: Observable<Array<DatePanelItems>> = this.dashboardFilterOptionsSubject.asObservable();

  private filterStateSubscription: Subscription;

  // Remove @Output() - update FilterStateService directly
  // @Output() onFilterChanged: EventEmitter<IDashboardFilterChangeEvent> = new EventEmitter<IDashboardFilterChangeEvent>();

  constructor(protected screen: ScreenService, private filterStateService: FilterStateService) {
   }
   
   ngOnInit(): void {
    // Subscribe to filter state and update local properties
    this.filterStateSubscription = this.filterStateService.filterState$.subscribe(
      (filterState) => {
        this.showCompleted = filterState.showCompleted;
        this.showRejected = filterState.showRejected;
        this.filterOptions = filterState.filterOptions;
        this.dashboardFilterOptionsSubject.next(this.filterOptions);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.filterStateSubscription) {
      this.filterStateSubscription.unsubscribe();
    }
  }

  onValueChanged(e: any, filter: DatePanelItems): void {
    filter.selectedItem = e.value; // Update the selected item
    console.log(`${filter.name} selected:`, filter.selectedItem);
    
    // Update FilterStateService directly instead of emitting events
    this.updateFilterState();
  }

  showCompletedValueChanged(e: any): void {
    this.showCompleted = e.value; // Update the showCompleted value
    
    // Update FilterStateService directly instead of emitting events
    this.updateFilterState();
  }

  showRejectedValueChanged(e: any): void {
    this.showRejected = e.value; // Update the showRejected value
    
    // Update FilterStateService directly instead of emitting events
    this.updateFilterState();
  }

  private updateFilterState(): void {
    console.log('Dashboard Header: updateFilterState called');
    const filterState = {
      showCompleted: this.showCompleted,
      showRejected: this.showRejected,
      filterOptions: this.filterOptions
    };
    
    this.filterStateService.saveFilterState(filterState);
  }

}
@NgModule({
  imports: [
  ],
  declarations: [ ],
  exports: [ ]
})
export class DashboardHeaderModule { }
